import throttle from "lodash/throttle";

import { createProject, allProjectFields, addContribution } from "../Participaid.svelte";
import { invitePerson, addContributor, updateContributor, all as allContributors } from "../Contributor.svelte";

// TODO: either test whether Apollo Batch works with the C# graphwl lib,
// or batch large graphql operations in single requests instead of running loops here

//
// CONFIG
//

// TODO: expose in admin panel
const TESTING = false;
//const INCLUDE_SELF = true;

// constants that determine seeding behaviour
const today = new Date();
const monthCount = 8;
const ENTRY_COUNT_DELTA = TESTING ? 3 : 100;
const ENTRY_COUNT_MIN = TESTING ? 1 : 50;
const CENTS = 100;
const MAX_AMOUNT = 1000;
const MAX_HOURS = 80;
const MAX_ATTACHMENTS = 3;
const MAX_SALARY_HOUR = 75;
const MIN_SALARY_HOUR = 10;
const MAX_SALARY_ANNUAL = 30000;
const MIN_SALARY_ANNUAL = 10000;
const MAX_COMMISSION_PERCENT = 5;

const TITLES = [
  "CEO",
  "CFO",
  "CTO",
  "CMO",
  "Mastermind",
  "Secretary",
  "Founder",
  "Investor",
  "Director",
  "Marketeer",
  "Developer",
  "Code Monkey",
  "Analyst",
  "Strategist",
  "UX Designer",
];

const ENTRY_FIELDS_TIME = [
  "Time (yearly salary)",
  "Time (hourly rate)"
];

const ENTRY_FIELDS_CURRENCY = [
  "Invoice (grant)",
  "Invoice (loan)",
  "Royalties & Commissions",
  "Expenses",
  "Assets & Materials"
];

const REJECTION_REASONS = [
  "Way too overvalued",
  "We agreed not to work on this",
  "Wrong method was used",
  "Resulting build actually doesn't compile",
  "Is not using a safe and proper language like Elm",
  "The job was not done with enough vigor",
  "Rejected due to my bad mood",
  "Spelling mistake in description",
  "Color of the purchase did not meet my expectation",
  "The stars are not in alignment",
  "Rejected in order to train the containment of your ego",
  "Missed the deadline",
  "Not in accordance with company strategy",
];

const ATTACHMENTS = [
  { fileType: "PDF", url: "https://www.startupbootcamp.org/wp-content/uploads/2012/09/Smart-T-E-Berlin-Investment-Agreement-Template.pdf"},
  { fileType: "XLSX", url: "https://docs.collectiveaccess.org/images/6/68/Sample_data.xlsx"},
  { fileType: "DOCX", url: "https://invoicetemplates.com/wp-content/uploads/Simple-Invoice-Template-No-Shipping.docx"},
  { fileType: "PPTX", url: "https://salesuni.nl/wp-content/upload_folders/salesuni.nl/1.-De-principes-van-een-sales-master.pptx"},
  { fileType: "OTHER", url: "https://raw.githubusercontent.com/usgs/geomag-algorithms/master/geomagio/algorithm/Algorithm.py"},
];

// identifiers for email addresses to use for adding collaborators
const CONTRIBUTORS = [
  "gijs", "luuk", "ben", "madeline", "tomas", "wouter", "rob", "patrick"
];

// prefab contribution templates
const CONTRIBUTIONS = [
  {
    description: "Implemented Evalueaid GraphQL server",
    tags: "backend,graphql,c#",
  },
  {
    description: "Wrote distributed server architecture specification in Clickup",
    tags: "clickup,spec,server"
  },
  {
    description: "Prepared cloud infrastructure provider for serverless auto-scaling",
    tags: "gcp,serverless,scaling"
  },
  {
    description: "Hired graphic designer to create playful icons and backgrounds for Svelte app",
    tags: "design,ui,ux"
  },
  {
    description: "Weekly standup with contractor",
    tags: "meeting,process,contractor"
  },
  {
    description: "Dreamt of elaborate marketing plan. See Clickup #2972y3r9r",
    tags: "marketing plan"
  },
  {
    description: "Grunted on Svelte frontend app deployment pipeline",
    tags: "svelte,frontend"
  },
  {
    description: "Debug mysterious Apollo.js error",
    tags: "svelte,frontend,apollo,graphql"
  },
  {
    description: "Researched possibilities for type-safe GraphQL programming in JS",
    tags: "svelte,frontend"
  },
  {
    description: "Adjusted CSS styling for a more premium-feel",
    tags: "css,frontend,styling"
  },
  {
    description: "Perfect Docker image for dependable build context",
    tags: "docker,devops,deployment"
  },
  {
    description: "Improve Project page using seed data",
    tags: "css,frontend,styling"
  },
  {
    description: "Blew all stakeholders away in a demo",
    tags: "demo,mvp,stakeholders"
  },
  {
    description: "Research JS libraries that could improve the DX",
    tags: "dx,libs,research"
  },
  {
    description: "Install Ngrok connection to show off local development environment",
    tags: "devops"
  },
  {
    description: "Inspiration for new logo that conveys all neccessary meaning",
    tags: "brand,logo"
  },
  {
    description: "Fix bug where app accidentally calls your mom",
    tags: "it,bug,fix"
  },
  {
    description: "Deduplicated issues in project management system",
    tags: "project management"
  },
  {
    description: "Trying to get rid of annoying customer that keeps wanting to throw cash at us",
    tags: "customer relations"
  },
  {
    description: "Skype call with developers about that thing",
    tags: "team,coordination,communication"
  },
  {
    description: "Research why functional programming is the future",
    tags: "research,strategy"
  },
  {
    description: "Looking into hearsay about Elm being awesome with GraphQL",
    tags: "dx,elm,research,graphql"
  },
  {
    description: "Research JS libraries that could improve the DX",
    tags: "dx,libs,research"
  },
  {
    description: "Fixed the printer",
    tags: "office,fix"
  },
  {
    description: "Bought proper Nescafe coffee machine",
    tags: "office,dx"
  },
  {
    description: "Research JS libraries that could improve the DX",
    tags: "dx,libs,research"
  },
  {
    description: "Thinking about ideal purely declarative programming language for frontend",
    tags: "dx,lang,research"
  },
  {
    description: "Trying to find the core reason why women are not attracted to our MVP",
    tags: "research,cognitive psychology"
  },
  {
    description: "Set up mock GraphQL server to use until contractor server has been released",
    tags: "testing,devops"
  },
  {
    description: "Cursing the Javascript ecosystem and build tools",
    tags: "communication,research"
  },
  {
    description: "Got coffee for the boss",
    tags: "office,team"
  },
  {
    description: "Complemented our primary investor",
    tags: "investor relations,communication"
  },
  {
    description: "Rejected Bill Gates for the vacant secretary position",
    tags: "team,qa"
  },
  {
    description: "Hired Jeff Bezos as cashier",
    tags: "team,hires"
  },
  {
    description: "Attended conference on Business Ethics 101",
    tags: "industry,learning"
  },
  {
    description: "Stole competitor's secret ingredient while working as janitor",
    tags: "sleuthing,industry,competitor analysis"
  },
  {
    description: "Rented Pablo Escobar island for company party",
    tags: "team building,festivities"
  },
  {
    description: "Pizzas for hackaton nerds",
    tags: "food"
  },
  {
    description: "Paid credit card debt of CEO's son",
    tags: "finance,H&R"
  },
];

//
// UTIL
//

const log = (msg) => {
  if (typeof msg == "string")
    console.log(`[Seed] ${msg}`);
  else {
    console.log(msg);
  }
};

// https://stackoverflow.com/a/951057/399058
const sleep = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
}

const random = (range) => Math.floor(Math.random() * range);
const randomSample = (arr) => arr[random(arr.length)];
// https://itnext.io/heres-why-mapping-a-constructed-array-doesn-t-work-in-javascript-f1195138615a
const randomList = (len) => [...Array(random(len))];
const randomEntryCount = () => (ENTRY_COUNT_MIN + random(ENTRY_COUNT_DELTA));

const randomDate = () => {
  let month = today.getMonth() + random(monthCount);
  let day = random(30);
  return new Date(
    ( new Date() ).setMonth(month, day)
  );
};

const randomEntryContainer = () => {
  const len = randomEntryCount();
  log(`initialized entry container of length ${len}`);
  return randomList(len)
};

const randomInputForField = (field) => {
  if (field.name.toLowerCase().includes("time")) {
    return {
      name: randomSample(ENTRY_FIELDS_TIME),
      unit: "hours",
      value: "" + random(MAX_HOURS)
    }
  }
  else {
    return {
      name: randomSample(ENTRY_FIELDS_CURRENCY),
      unit: "currency",
      value: "" + (random(MAX_AMOUNT) * CENTS)
    }
  }
}

// TODO: we need the project start date to be set in the past for these purposes...
// otherwise we can only register contributions in te current administration period..
const randomProject = (isOwner) => {
  return {
     title: `Example Project #${random(999999)} (as ${(isOwner) ? "owner" : "participant"})`,
     settlementDateTarget: new Date( today.setMonth(today.getMonth()+monthCount) ),
     visibilityTeam: true,
     defaultAcceptancePolicy: "MANUAL",
     allowBackTracking: true,
     administrationPeriodType: "WEEKLY",
     companySharePercentage: 100.0,
     companySharePrice: 1*CENTS,
     companyValuation: 500000.0*CENTS,
     stockCalculationStrategy: "DISTRIBUTE_BASED_ON_STOCK_VALUE"
  }
};

const randomEmail = (name) => `${name}-${random(99999999)}@example.com`;
const randomTitle = () => randomSample(TITLES);
const randomReason = () => randomSample(REJECTION_REASONS);

const randomContribution = (contributorUserId, inputValue) => {
  let date = randomDate();
  let attachments = randomList(MAX_ATTACHMENTS).map(() => randomSample(ATTACHMENTS));

  return {
    ...randomSample(CONTRIBUTIONS),
    ...{
      inputValue,
      contributionDate: date.toISOString(),
      review: randomReview(date),
      collaboratorUser: {
        id: contributorUserId
      },
      //attachments
    }
  };
};

const randomReview = (cDate) => {
  switch (random(3)) {
    case 0: {
      return {
        acceptanceStatus: "ACCEPTANCE_PENDING"
      };
    }
    case 1: {
      return {
        acceptanceStatus: "ACCEPTED",
        dateOfReview: new Date( cDate.getDate()+random(7))
      };
    }
    case 2: {
      return {
        acceptanceStatus: "REJECTED",
        reasonForRejection: randomReason(),
        dateOfReview: new Date( cDate.getDate()+random(7))
      };
    }
  }
};

const randomContributor = (id) => {
  return {
    id,
    title: randomTitle(),
    marketAnnualSalary: (MIN_SALARY_ANNUAL+random(MAX_SALARY_ANNUAL))*CENTS,
    hourlySalary: random(MAX_SALARY_HOUR)*CENTS,
    currency: "euro",
    commissionPercentage: random(MAX_COMMISSION_PERCENT),
    startDate: today.toISOString(),
  };
};

// resolve promises sequentially instead of using Promise.all
const requestAll = (promises, sleepTime) => {
  let results = [];

  return promises
    /*.map( (promise) => (result) => {
      if (result)
        results.push(result);
      return sleep(sleepTime || 0).then(() => promise);
    })*/
    .reduce(
      (p, fn) => p.then(res => {
        if (res)
          results.push(res);
        return (typeof fn === 'function') ? fn() : fn;
      }),
      Promise.resolve()
    )
    .then(_ => results)
    .catch(err => {
      console.error(err);
      throw "there was an error in a requestsAll() call";
    })
}

//
// OPS
//

// create contributor as if we were logged in as this invited person (impersonate).
// finally return the result of the user creation itself
const seedContributor = (projectId, contributor, userToken) => {
  log(`Impersonating newly registered user for creation of Contributor...`);
  log(`
      person id: #${contributor.user.id},
      login token: ...${userToken.substr(userToken.length-7)}
  `);

  return updateContributor(
    projectId,
    randomContributor(contributor.id),
    userToken
  )
    .then(contrRes => ({
      ...contrRes,
      projectId
    }))
};

// using a response object of the project creation, add
// new random people
const seedProjectPeople = (projectRes) => {
  let projectId = projectRes.data.addProject.id;
  log(`seeding project people for ${projectId}`);

  // make a contributor for ourselves, or we do not have admin access...
  if (projectRes.data.addProject.title.includes("owner")) {
    addContributor(projectId, {
      ...randomContributor(),
      ...{title: "Project Owner"}
    });
  }

  return requestAll(
    CONTRIBUTORS
      .map((email) => (_prevRes) =>
        invitePerson(projectId, randomEmail(email), email, "Surname")
          .then(personRes =>
            seedContributor(
              projectId,
              personRes.contributor,
              personRes.token
            )
          )
      )
  )
};

const seedProjectContributions = (projectId) => {
  return allProjectFields(projectId).then(fieldsRes => {
    log("received Field details for project:");
    log(fieldsRes);

    const throttledSeedContribution = throttle(seedContribution, 750);

    log("getting all contributor IDs...");
    return allContributors(projectId, true).then(contributorsRes => {
      if (contributorsRes.data.contributors.length < CONTRIBUTORS.length)
        throw `Did not receive enough contributor items!`;

      log("seeding contributions for contributor...");
      return requestAll(
        contributorsRes
          .data
          .contributors
          .map(contr => requestAll(
            randomEntryContainer().map( (_item) => (_prevRes) =>
              seedContribution(
                projectId,
                contr.user.id,
                fieldsRes.data.projectFields
              )
            )
          ))
      );
    });
  });
};

// using the response object of adding the project, add
// random contrbutions for the created people
const seedContributions = (contributors) => {
  log(`seeding contributions...`);
  log("result for seeding people:");
  log(contributors);
  let projectId = contributors[0].projectId;
  return seedProjectContributions(projectId);
};

// given a single addContributor result, return
// a closure function that returns the operation of adding
// a random contribution for the given contributor
const seedContribution = (projectId, contributorId, fields) => {
  const randomField = fields[random( fields.length )];
  const randomInput = randomInputForField(randomField);
  const contribution = randomContribution(
    contributorId,
    randomInput
  );

  const throttledAddContribution = throttle(addContribution, 750);

  log("seeding randomized contribution for contributor: #" + contributorId);
  log(contribution);

  return addContribution(
    projectId,
    randomField.id,
    contribution
  )
};

const Seed = {
  // 160ecfef-d7e1-4a5f-94d1-ede687808514
  newProject: (companyId, owner) => {
    log(`starting seed for company ${companyId}...`);

    return createProject(companyId, randomProject(owner))
      .then(seedProjectPeople)
      .then(seedContributions)
      .then(res => log("DONE seeding project"))
  },

  project: seedProjectContributions,
};

export default Seed;